import React from 'react'
import styled from 'styled-components'
import { AiOutlineSave } from 'react-icons/ai'
import { FaRegEdit } from 'react-icons/fa'
import moment from 'moment'

import { CompanyInfoFirstCol } from './first-column'
import { CompanyInfoSecondCol } from './second-column'
import { CustomDatePicker } from '../../../datepicker'
import { TextArea } from '../../../input'
import { Button } from '../../../buttons'
import { FONTS } from '../../../../constants'

export const CompanyInfo = props => {
  const {
    emp,
    users,
    invalid,
    isEditCompany,
    handleInput,
    handleCheckbox,
    handleClickEdit,
    handleClickCancel,
    handleSaveCompany,
  } = props

  return (
    <Root>
      <Container>
        <SectionText>Company Information</SectionText>
        <Wrapper>
          <Form>
            <CompanyInfoFirstCol
              users={ users }
              emp={ emp }
              invalid={ invalid }
              isEditCompany={ isEditCompany }
              handleInput={ handleInput }
            />
            <CompanyInfoSecondCol
              users={ users }
              emp={ emp }
              isEditCompany={ isEditCompany }
              handleInput={ handleInput }
              handleCheckbox={ handleCheckbox }
            />
          </Form>
          <LabelCol>
            <Label>Description</Label>
          </LabelCol>
          <InputCol>
            <TextArea
              name='remark'
              placeholder='Enter Remark'
              maxlength={ 500 }
              disabled={ !isEditCompany }
              value={ emp.remark || '' }
              onChange={ e => handleInput(e.target.value, 'remark') }
            />
          </InputCol>
        </Wrapper>
        <SectionText>Resignation</SectionText>
        <Wrapper>
          <FormGroup>
            <FormWrapper>
              <LabelCol>
                <Label>Last Effective Date</Label>
              </LabelCol>
              <InputCol>
                <CustomDatePicker
                  showYearDropdown
                  showMonthDropdown
                  autoComplete='off'
                  name='last_effective_date'
                  dateFormat='DD/MM/YYYY'
                  disabled={ !isEditCompany }
                  selected={ emp.last_effective_date ? moment(emp.last_effective_date) : null }
                  onChange={ e => handleInput(e, 'last_effective_date') }
                />
              </InputCol>
            </FormWrapper>
            <FormWrapper>
              <LabelCol>
                <Label>Last Working Date</Label>
              </LabelCol>
              <InputCol>
                <CustomDatePicker
                  showYearDropdown
                  showMonthDropdown
                  autoComplete='off'
                  name='last_working_date'
                  dateFormat='DD/MM/YYYY'
                  disabled={ !isEditCompany }
                  selected={ emp.last_working_date ? moment(emp.last_working_date) : null }
                  onChange={ e => handleInput(e, 'last_working_date') }
                />
              </InputCol>
            </FormWrapper>
          </FormGroup>
          <LabelCol>
            <Label>Remark</Label>
          </LabelCol>
          <InputCol>
            <TextArea
              name='resign_remark'
              placeholder='Enter Remark'
              maxlength={ 500 }
              disabled={ !isEditCompany }
              value={ emp.resign_remark || '' }
              onChange={ e => handleInput(e.target.value, 'resign_remark') }
            />
          </InputCol>
        </Wrapper>
      </Container>
      <Footer>
        <ButtonGroup>
          { isEditCompany ?
            <ButtonGroup>
              <Button
                theme='#28a745'
                icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
                width='70px'
                height='26px'
                disabled={ Object.keys(invalid).length > 0 }
                onClick={ () => handleSaveCompany(emp) }
              >
              Save
              </Button>
              <Button
                theme='#6c757d'
                width='70px'
                height='26px'
                onClick={ () => handleClickCancel(emp.user_id) }
              >
              Cancel
              </Button>
            </ButtonGroup>
            :
            <Button
              theme='#28a745'
              icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
              width='70px'
              height='26px'
              onClick={ () => handleClickEdit(1) }
            >
              Edit
            </Button>
          }
        </ButtonGroup>
      </Footer>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
`

const Container = styled.div`
  padding: 16px 24px;
  background: #FFFFFF;
  max-height: calc(100vh - 223px);
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  flex: 1;
`

const FormGroup = styled.div`
    display: flex;
    flex: 1;
    margin-bottom: 16px;
`

const LabelCol = styled.div`
    display: flex;
    flex: 1;
`

const InputCol = styled.div`
    display: flex;
    flex: 2;

    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const Footer = styled.div`
  height: 42px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #F9F9F9;
  padding: 0 24px;
`

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;

    div:nth-last-child(1) {
      margin-left: 12px;
    }
`

const Form = styled.div`
  display: flex;
  margin-top: 12px;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  margin-bottom: 24px;
`

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  :nth-child(1) {
      padding-right: 6px;
  }

  :nth-last-child(1) {
      padding-left: 6px;
  }
`

const SectionText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #000000;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/edit-pane/company-info/index.js